import { LeftNavProvider } from '@fluentsms/agentnet-web-components';
import { AuthProvider } from '@fluentsms/auth';
import { CssBaseline, NotificationDataProvider, ProductFruits, theme, ThemeProvider } from '@fluentsms/components';
import { ErrorBoundary } from '@fluentsms/error-pages';
import { useIsFeatureEnabled, withFeatureFlagProvider } from '@fluentsms/feature-flags';
import { GraphQlProvider } from '@fluentsms/graphql';
import { SnackbarProvider } from '@fluentsms/snackbar';
import { AblyProvider } from '@fluentsms/subscriptions';
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import Routes from './Routes';

function _App(): JSX.Element {
  const enableProductFruits = useIsFeatureEnabled('platform-2063230-product-fruits');

  return (
    <div className="App" data-testid="app">
      <BrowserRouter>
        <ErrorBoundary>
          <AuthProvider>
            <GraphQlProvider>
              <AblyProvider enableDebug={false}>
                <ThemeProvider theme={theme}>
                  <LeftNavProvider>
                    <NotificationDataProvider>
                      <SnackbarProvider>
                        <CssBaseline />
                        {enableProductFruits && <ProductFruits />}
                        <Routes />
                      </SnackbarProvider>
                    </NotificationDataProvider>
                  </LeftNavProvider>
                </ThemeProvider>
              </AblyProvider>
            </GraphQlProvider>
          </AuthProvider>
        </ErrorBoundary>
      </BrowserRouter>
    </div>
  );
}

const App = withFeatureFlagProvider(_App);
export default App;
